// Circular profile image with the existing initials fallback (default avatar).
import styles from './AvatarPicker.module.css';

function ProfileAvatar({ url, name, size = 72 }) {
    const box = { width: size, height: size };
    return url ? (
        <img src={url} alt={name || 'Profile picture'} className={styles.avatar} style={box} />
    ) : (
        <span className={styles.avatarFallback} style={{ ...box, fontSize: size * 0.4 }} aria-label={name || 'Profile picture'}>
            {(name?.[0] ?? '?').toUpperCase()}
        </span>
    );
}

export default ProfileAvatar;
